import React from 'react';

export default function ThemeToggle({ theme, onToggle, floating }) {
    const isLight = theme === 'light';
    return (
        <button
            type="button"
            className={'theme-toggle ' + (floating ? 'is-floating' : '')}
            onClick={onToggle}
            title={isLight ? 'Switch to dark mode' : 'Switch to light mode'}
            aria-label={isLight ? 'Switch to dark mode' : 'Switch to light mode'}
        >
            <span className="theme-toggle-icon" aria-hidden="true">
                {isLight ? (
                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
                        <circle cx="12" cy="12" r="4" />
                        <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4L7 17M17 7l1.4-1.4" />
                    </svg>
                ) : (
                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" />
                    </svg>
                )}
            </span>
            <span className="theme-toggle-label">
                {isLight ? 'Light' : 'Dark'}
            </span>
        </button>
    );
}
